import { useEffect, useRef, useState } from "react";
import "./labelsModal.css";
import { useDispatch, useSelector } from "react-redux";
import { HandleLabelsAPI } from "../../../../../../../../store/api/get/Labels/Labels";
import { TOGGLE_CARD_LABEL } from "../../../../../../../../store/constants";

export const LabelsModal = ({ onClose, position, triggerRef }) => {
    const modalRef = useRef(null);
    const card = useSelector((state) => state.boards.activeCard);
    const dispatch = useDispatch();
    const labels = useSelector((state) => state.labels.labels);
    const [updatedLabels, setUpdatedLabels] = useState([]);
    const [checkedLabels, setCheckedLabels] = useState({});
    const user = useSelector(state => state.user.user);
    const activeBoard = useSelector(state => state.boards.activeBoard);
    const userRole = activeBoard?.rbac?.find(
        (el) => el.user_id === user?.id
    )?.role;
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };

        const handleClickOutside = (e) => {
            const clickedPopover = modalRef.current?.contains(e.target);
            const clickedTrigger = triggerRef?.current?.contains(e.target);

            if (!clickedPopover && !clickedTrigger) {
                onClose();
            }
        };

        document.addEventListener("keydown", handleEsc);
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("keydown", handleEsc);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    useEffect(() => {
        const initialState = {};

        card?.labels?.forEach((item) => {
            initialState[item.label_id] = item.is_checked;
        });

        setCheckedLabels(initialState);
    }, [card]);

    useEffect(() => {
        const selectedIds = new Set(card?.labels?.map((l) => l.label_id));

        const merged = labels.map((label) => ({
            ...label,
            is_checked: selectedIds.has(label.id),
        }));

        setUpdatedLabels(merged);
    }, [card, labels]);

    const updateLabelSelection = async (label_id, is_checked) => {
        setCheckedLabels((prev) => ({
            ...prev,
            [label_id]: is_checked,
        }));

        const currentLabel = labels.find((label) => label.id === label_id);

        dispatch({
            type: TOGGLE_CARD_LABEL,
            payload: {
                label: currentLabel,
                is_checked,
            },
        });

        await dispatch(HandleLabelsAPI(card.id, label_id, is_checked));
    };

    const handleCheck = (e, label_id) => {
        updateLabelSelection(label_id, e.target.checked);
    };

    return (
        <div
            className="labelsPopover"
            ref={modalRef}
            style={{
                top: `${position.top}px`,
                left: `${position.left}px`,
            }}
        >
            <div className="labelsPopover__header">
                <h3>Labels</h3>
                <button
                    className="labelsPopover__close"
                    type="button"
                    onClick={onClose}
                >
                    ×
                </button>
            </div>
            <div className="labelsPopover__title">Labels</div>
            <div className="labelsPopover__list">
                {updatedLabels.map((label) => {
                    const isChecked = checkedLabels[label.id] ?? label.is_checked ?? false;

                    return (
                        <div className="labelsPopover__row" key={label.id}>
                            <label className="labelsPopover__checkbox">
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={(e) => userRole !== 1 && handleCheck(e, label.id)}
                                />
                                <span></span>
                            </label>

                            <button
                                type="button"
                                className="labelsPopover__color"
                                style={{ backgroundColor: label.color }}
                                onClick={() => updateLabelSelection(label.id, !isChecked)}
                                disabled={userRole === 1}
                                aria-pressed={isChecked}
                                aria-label={`${isChecked ? "Deselect" : "Select"} label`}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
